import VueScrollMonitor from 'vue-scrollmonitor';
import Vue from 'vue';

Vue.use(VueScrollMonitor);
